import NextImage from "@/components/global/NextImage";
import AddIcon from "@/components/icons/AddIcon";
import CheckIcon from "@/components/icons/CheckIcon";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
import EqualIcon from "@/components/icons/EqualIcon";
import { useCart } from "@/context/cart";
import { ModalContext } from "@/pages/_app";
import { validateImgSrc } from "@/utils/global";
import { validateDiscountPrice } from "@/utils/product/CalcDiscount";
import { handleAddItemsToCart } from "@/utils/product/addToCartFunc";
import { Fragment, useContext, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const AddOnSavings = ({
  parentProduct,
  t,
  configurations,
  relatedProducts,
}) => {
  const context = useContext(ModalContext);
  const bundleDiscountProducts = parentProduct?.ulmod_bundles
    ?.map((o) => o?.product_links)
    .map((l) => l?.at(0));

  const { dispatch } = useCart();
  const [loading, setLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(
    bundleDiscountProducts
  );

  function toggleSelect(product) {
    const selectedIds = selectedProducts?.map((i) => i?.id) || [];
    if (selectedIds?.includes(product?.id)) {
      setSelectedProducts((prev) =>
        prev?.filter((item) => item?.id != product?.id)
      );
    } else {
      setSelectedProducts((prev) => [...prev, product]);
    }
  }

  const calculateTotal = useMemo(() => {
    return [parentProduct, ...selectedProducts]?.reduce((agg, curr) => {
      return agg + Number(curr?.prices_with_tax?.price);
    }, 0);
  }, [selectedProducts, parentProduct]);
  const bundleTotal = calculateTotal;
  console.log(
    "parentProduct, ...selectedProducts ------ AddOnSavings",
    [parentProduct, ...selectedProducts]?.map((p) => ({
      sku: typeof p.sku == "string" ? p?.sku : p?.sku?.at(0),
      qty: 1,
    }))
  );
  console.log("configurations ------ ", configurations);
  return (
    <section>
      {/* <h3 className="text-lg font-bold max-sm:text-sm">
        {t(bundle?.block_title)}
      </h3> */}
      <p className="mt-2 text-lg max-sm:text-sm">
        <span className="font-bold">
          {t("The more you Add-On the more you save")}{" "}
        </span>
        {/* <span>
          (when you buy the Nikon Z8 Mirrorless Camera and Audio Recording Kit)
        </span> */}
      </p>
      <div className="flex gap-4 my-4 mb-6 max-sm:flex-col ">
        <div className="flex items-center gap-6 overflow-x-auto">
          {[parentProduct, ...selectedProducts]?.map(
            (item, i) =>
              [parentProduct, ...selectedProducts]
                ?.map((i) => i?.id)
                ?.includes(item?.id) && (
                <Fragment key={uuidv4()}>
                  <NextImage
                    src={validateImgSrc(item?._media_?.image?.at(0)?.image)}
                    className="object-contain size-20 max-sm:size-10"
                    alt="Bundle Discount Img!"
                    width={80}
                    height={80}
                  />
                  <button
                    className={`bg-[#EAE8E880] p-2 items-center justify-center rounded-sm ${
                      i >= [parentProduct, ...selectedProducts]?.length - 1
                        ? "hidden"
                        : "flex"
                    } max-sm:p-1`}
                  >
                    <AddIcon className="max-sm:size-3" />
                  </button>
                </Fragment>
              )
          )}
        </div>
        {[parentProduct, ...selectedProducts]?.length > 0 && (
          <div className="flex items-center justify-center gap-3 max-sm:flex-col">
            <button className="bg-[#EAE8E880] max-sm:hidden p-1 sm:p-2 size-8 flex items-center justify-center">
              <EqualIcon className="max-sm:size-3" />
            </button>
            <div className="flex flex-col justify-center gap-1 *:whitespace-nowrap">
              <span className="font-bold text-center flex items-center gap-1 justify-center text-[#4861A7] text-sm sm:text-lg">
                {bundleTotal} <CurrencyIcon className="size-3.5" />
              </span>
              <button
                onClick={() =>
                  handleAddItemsToCart(
                    [parentProduct, ...selectedProducts]?.map((p) => ({
                      sku: typeof p.sku == "string" ? p?.sku : p?.sku?.at(0),
                      qty: 1,
                    })),
                    setLoading,
                    dispatch,
                    configurations,
                    context,
                    relatedProducts,
                    selectedProducts
                  )
                }
                className="flex items-center justify-center gap-2 p-2 text-xs text-white rounded-md sm:text-sm bg-primary min-w-52"
              >
                {loading && <div className="w-6 loader" />}
                <p>{t("Add to cart")}</p>
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <p className="my-4 text-sm font-bold sm:text-lg">
        Nikon Z8 Mirrorless Camera and Audio Recording Kit
      </p> */}
      <section className="flex flex-col gap-5 overflow-x-auto overflow-y-hidden max-sm:gap-2">
        {bundleDiscountProducts?.map((item) => (
          <div
            key={item?.id}
            className="flex items-center justify-between mb-4 gap-7 last:mb-0 max-sm:gap-3"
          >
            <div className="flex items-center gap-2 sm:gap-4">
              <span
                onClick={() => toggleSelect(item)}
                className={`size-6 max-sm:size-4 cursor-pointer ${
                  selectedProducts?.map((i) => i.id)?.includes(item?.id)
                    ? "bg-[#734B93] text-white"
                    : "bg-gray-100 border-gray-100 text-black"
                } grid place-items-center`}
              >
                {selectedProducts?.map((i) => i.id)?.includes(item?.id) && (
                  <CheckIcon className=" size-2 sm:size-3" />
                )}
              </span>
              <div className="text-base max-sm:text-xs max-sm:max-w-48 max-sm:line-clamp-3 max-sm:h-fit max-sm:leading-6 min-md:whitespace-nowrap">
                {item?.name}
              </div>
            </div>
            <div className="flex items-center gap-3 sm:gap-8 max-sm:text-xs">
              {validateDiscountPrice(item) && (
                <p className="text-[#B4AFAF] line-through whitespace-nowrap flex items-center gap-1">
                  {Number(item?.prices_with_tax?.original_price)}{" "}
                  <CurrencyIcon className="size-3.5" />
                </p>
              )}
              <p className="text-[#4861a7] font-bold whitespace-nowrap flex items-center gap-1">
                {item?.prices_with_tax?.discounted_price}{" "}
                <CurrencyIcon className="size-3.5" />
              </p>
            </div>
          </div>
        ))}
      </section>
    </section>
  );
};

export default AddOnSavings;
